import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { menuAnatomy } from '@chakra-ui/anatomy';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(menuAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    list: {
      zIndex: 1000,
      borderRadius: getThemes(theme).radii['2xl'],
      borderColor: getThemes(theme).colors.palette.primary[95],
      px: 0,
      py: 2,
      overflow: 'hidden',
    },
    groupTitle: {
      marginTop: 0,
      marginBottom: 4,
      fontSize: 'md',
      fontFamily: 'inter',
      fontWeight: '600',
      marginInlineStart: 5,
      paddingTop: 2,
    },
    item: {
      fontFamily: 'inter',
      fontWeight: '400',
      px: 6,
      marginBottom: 0,
      _hover: {
        bg: getThemes(theme).colors.palette.primary[95],
      },
    },
    divider: {
      borderColor: getThemes(theme).colors.palette.neutral[60],
    },
  });

export const dropdownTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
  });

export default (theme: any) => dropdownTheme(theme);
